import { createAction } from 'redux-actions';

export const GetOuterServerMailRequested = createAction('GET_OUTER_SERVER_MAIL_REQUESTED');
export const GetOuterServerMailReceived = createAction('GET_OUTER_SERVER_MAIL_RECEIVED');
export const GetOuterServerMailFailed = createAction('GET_OUTER_SERVER_MAIL_FAILED');
export const ClearGetOuterServerMail = createAction('CLEAR_GET_OUTER_SERVER_MAIL');

export const UpdateOuterServerMailRequested = createAction('UPDATE_OUTER_SERVER_MAIL_REQUESTED');
export const UpdateOuterServerMailReceived = createAction('UPDATE_OUTER_SERVER_MAIL_RECEIVED');
export const UpdateOuterServerMailFailed = createAction('UPDATE_OUTER_SERVER_MAIL_FAILED');
export const ClearUpdateOuterServerMail = createAction('CLEAR_UPDATE_OUTER_SERVER_MAIL');

export const DeleteOuterServerMailRequested = createAction('DELETE_OUTER_SERVER_MAIL_REQUESTED');
export const DeleteOuterServerMailReceived = createAction('DELETE_OUTER_SERVER_MAIL_RECEIVED');
export const DeleteOuterServerMailFailed = createAction('DELETE_OUTER_SERVER_MAIL_FAILED');
export const ClearDeleteOuterServerMail = createAction('CLEAR_DELETE_OUTER_SERVER_MAIL');
